/* STATION WIRE · V89 · (c) 2026 Lund Studio LLC
   Wires FEHU into the live ship: per-vessel hues from the data-add value,
   ABOARD only on the platform's yes, the launch bar into airlockSeq. */
(function () {
  "use strict";
  if (typeof document === "undefined" || !window.FEHU || window.__STATION_WIRE__) return;
  window.__STATION_WIRE__ = "89";
  var lastP = null;


  /* ---- V91 · the claim CTAs join the grammar ----
     station-claim.js cycles their fill inline every 1.7s; we mirror that
     live colour into --fehu-hue so the glow, ring and focus track the hue. */
  function mirrorHue(el){
    var bg = el.style.background || el.style.backgroundColor || "";
    var m = bg.match(/#[0-9a-f]{3,8}|rgba?\([^)]+\)/i);
    if (m) el.style.setProperty("--fehu-hue", m[0]);
  }
  function claimCTAs(){
    return [].slice.call(document.querySelectorAll(".claim-btn, .menu-cta, .sb-buy, .bp-go"));
  }
  function watchClaims(){
    var els = claimCTAs();
    els.forEach(mirrorHue);
    if (typeof MutationObserver === "undefined") return;
    var mo = new MutationObserver(function(recs){
      for (var i=0;i<recs.length;i++) mirrorHue(recs[i].target);
    });
    els.forEach(function(el){ mo.observe(el, { attributes:true, attributeFilter:["style"] }); });
  }

  /* ---- V91 · THE THRUSTERS ----
     Two nozzles with live flame on every LAUNCH control, so the button
     reads as a rocket lighting up rather than a link. */
  var NOZ = '<span class="st-thrust" aria-hidden="true">' +
    '<svg class="st-noz" viewBox="0 0 11 22"><path d="M2.2 0 h6.6 l1.2 6 h-9 Z" fill="currentColor" opacity=".92"/>' +
      '<g class="st-flame"><path d="M5.5 21.5 C2.4 17.6 2.0 12.2 5.5 6.6 C9.0 12.2 8.6 17.6 5.5 21.5 Z" fill="#F8E44B"/>' +
      '<path d="M5.5 18.2 C3.9 15.6 3.8 12.3 5.5 8.6 C7.2 12.3 7.1 15.6 5.5 18.2 Z" fill="#FFF4C2"/></g></svg>' +
    '<svg class="st-noz" viewBox="0 0 11 22"><path d="M2.2 0 h6.6 l1.2 6 h-9 Z" fill="currentColor" opacity=".92"/>' +
      '<g class="st-flame st-flame-2"><path d="M5.5 21.5 C2.4 17.6 2.0 12.2 5.5 6.6 C9.0 12.2 8.6 17.6 5.5 21.5 Z" fill="#FC4539"/>' +
      '<path d="M5.5 18.2 C3.9 15.6 3.8 12.3 5.5 8.6 C7.2 12.3 7.1 15.6 5.5 18.2 Z" fill="#F8E44B"/></g></svg>' +
    '</span>';
  function ignite(el){
    if (!el || el.querySelector(".st-thrust")) return;
    el.insertAdjacentHTML("beforeend", NOZ);
  }
  function igniteAll(){
    var bar = document.querySelector(".fehu-bar .fehu");
    if (bar) ignite(bar);
    [].slice.call(document.querySelectorAll(".airlock-launch, [data-launch-go], #maniGo, #lpGoBtn"))
      .forEach(ignite);
  }

  function sync() {
    if (!/^https?:$/.test(location.protocol)) return;
    try { fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && typeof c.item_count === "number") FEHU.setCount(c.item_count); })
      .catch(function () {}); } catch (e) {}
  }
  function landed(url, ok) {
    if (!ok) { if (lastP) FEHU.restore(lastP); lastP = null; return; }
    if (url.indexOf("/cart/add") > -1) { FEHU.aboard(lastP); lastP = null; sync(); }
    else if (/\/cart\/(change|update|clear)/.test(url)) { sync(); }
  }
  if (window.fetch) {
    var OF = window.fetch;
    window.fetch = function (u) {
      var url = ""; try { url = typeof u === "string" ? u : (u && u.url) || ""; } catch (e) {}
      var p = OF.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function (r) { landed(url, !!(r && r.ok)); }).catch(function () { landed(url, false); });
      }
      return p;
    };
  }
  if (window.XMLHttpRequest) {
    var OP = XMLHttpRequest.prototype.open, SE = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__st_url = u || ""; return OP.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var x = this;
      if (/\/cart\/(add|change|update|clear)/.test(x.__st_url || "")) {
        x.addEventListener("loadend", function () { landed(x.__st_url, x.status >= 200 && x.status < 300); });
      }
      return SE.apply(this, arguments);
    };
  }
  function boot() {
    FEHU.attach({
      primary: "[data-add]", second: "[data-launch]",
      hue: "#00CE7E", hueKey: "data-add",
      hueMap: { "v-green": "#00CE7E", "v-pink": "#EA41AA", "v-red": "#FC4539",
                "v-yellow": "#F8E44B", "v-blue": "#389EE1" },
      subline: "", auto: false, observe: true
    });
    FEHU.bar({
      label: "LAUNCH \u2192", hue: "#00CE7E",
      line: function (n) { return n + " ABOARD"; },
      onLaunch: function () {
        if (typeof window.airlockSeq === "function") return window.airlockSeq();
        window.location.href = "/cart";
      }
    });
    document.addEventListener("click", function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-fehu-dressed="primary"]') : null;
      if (b) lastP = b;
    }, true);
    watchClaims();
    igniteAll();
    setTimeout(igniteAll, 600);
    /* PDP form: claim in place, confirm on the cart's yes, native post as fallback */
    document.addEventListener("submit", function (ev) {
      var f = ev.target;
      if (!f || !f.action || f.action.indexOf("/cart/add") === -1) return;
      var btn = f.querySelector("[data-add]");
      if (!btn || !window.fetch || !window.FormData) return;
      ev.preventDefault();
      lastP = btn; FEHU.busy(btn);
      fetch("/cart/add.js", { method: "POST", credentials: "same-origin", body: new FormData(f) })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function () { FEHU.aboard(btn); lastP = null; sync(); })
        .catch(function () { FEHU.restore(btn); lastP = null; f.submit(); });
    }, true);
    sync();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
